export default __webpack_public_path__ + "static/media/pexels-yan-5478927.699ac351.mp4";